export default __webpack_public_path__ + "static/media/drizzle-night.f62c0fb5.svg";